import React, { useContext } from 'react';
import { ProductDetailsContext } from '../../context';
import { FormattedMessage } from 'react-intl';
import { messages } from './aliases/messages';
import style from './style.module.css';

export const ProductAliasesTabTitle = () => {
  const { productAliases } = useContext(ProductDetailsContext);
  return (
    <div>
      <FormattedMessage {...messages.aliasesTitle} />
      {productAliases.length > 0 && <span className={style['alias-count']}>{productAliases.length}</span>}
    </div>
  );
};
